/**
 * Route for `csv-xlsx-attachment-on-scheduled-report`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CsvXlsxAttachmentOnScheduledReportPage } from "../features/csv-xlsx-attachment-on-scheduled-report/CsvXlsxAttachmentOnScheduledReportPage";

export const csvXlsxAttachmentOnScheduledReportRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/csv-xlsx-attachment-on-scheduled-report",
	component: CsvXlsxAttachmentOnScheduledReportPage,
});

export default csvXlsxAttachmentOnScheduledReportRoute;
